import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-201944a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "manual-modal"
}
const _hoisted_2 = { class: "manual-content" }

import ManualViewer from './ManualViewer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ManualModal',
  props: {
    visible: { type: Boolean },
    section: null
  },
  emits: ['close'],
  setup(__props: any) {

const props = __props as {
  visible: boolean
  section?: string  // null = mostra tutto
};





return (_ctx: any,_cache: any) => {
  return (__props.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "close-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, "✕"),
          _createVNode(ManualViewer, { section: __props.section }, null, 8, ["section"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})